import { Injectable, signal } from '@angular/core';

export type PortalLang = 'en' | 'hi';

const STORAGE_KEY = 'pda-portal-lang';

@Injectable({ providedIn: 'root' })
export class PortalLocaleService {
  readonly lang = signal<PortalLang>(this.readStored());

  constructor() {
    this.applyDocumentLang(this.lang());
  }

  pick(en: string, hi: string): string {
    return this.lang() === 'hi' ? hi : en;
  }

  setLang(next: PortalLang): void {
    this.lang.set(next);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, next);
    }
    this.applyDocumentLang(next);
  }

  private readStored(): PortalLang {
    if (typeof localStorage === 'undefined') return 'en';
    return localStorage.getItem(STORAGE_KEY) === 'hi' ? 'hi' : 'en';
  }

  private applyDocumentLang(lang: PortalLang): void {
    if (typeof document === 'undefined') return;
    document.documentElement.classList.toggle('lang-hi', lang === 'hi');
  }
}
